
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloadAppTalent",
      function () {
        return require("private-next-pages/downloadAppTalent/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloadAppTalent"])
      });
    }
  